import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import StateContainer from 'components/StateContainer';
import { getApplicationData } from 'selectors/getApplicationData';
import { ReactComponent as LoadingSpinner } from 'images/loader.svg';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { preVerifyApplication, verifyApplication } from 'thunks';
import { FlowComponentType } from 'routes/types';
import { RoutePath } from 'enums/Routes';
import { useNavigate } from 'hooks/useNavigate';
import FormContainer from 'components/LoanForm/FormContainer';

const VerifyingApplication = ({ handleNext }: FlowComponentType) => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const navigate = useNavigate();

  const { application, paystubsUploaded } = useSelector(getApplicationData);
  const { id: applicationId } = application!;
  const verificationStepsProgress = application?.verificationStepProgress;

  useEffect(() => {
    (async () => {
      try {
        if (!paystubsUploaded && !verificationStepsProgress?.paystubs) {
          // First call preVerify to check if we need to show VerifyIncome screen
          const preVerifyResult = await dispatchWithUnwrap(preVerifyApplication(applicationId));

          if (preVerifyResult?.paystubsRequired) return navigate(RoutePath.UploadIncomeVerification);
          if (preVerifyResult?.needsVerifyIncomeOption) return navigate(RoutePath.VerifyIncome);
        }

        // Otherwise, proceed with normal verification
        const { iovation_blackbox: iovationBlackbox } = window as any;

        if (!iovationBlackbox) {
          throw new Error('iovationBlackbox is undefined');
        }

        (window as any).nid('applicationSubmit', 'kycCheck');
        (window as any).nid('closeSession');

        const result = await dispatchWithUnwrap(
          verifyApplication({ applicationId, kycVariables: { iovationBlackbox } }),
        );
        analytics.track('Verify Result', result);
        handleNext(result.status);
      } catch (error) {
        handleNext();
      }
    })();
  }, []);

  return (
    <FormContainer>
      <StateContainer icon={<LoadingSpinner />} title="Verifying..." />
    </FormContainer>
  );
};

export default VerifyingApplication;
